<ng-container *ngIf="extendedSimulationData$ | async as data">
  <!-- simulation row template -->
  <ng-template #simulationRow let-data="data">
    <td>
      {{
        ('feed-profit.detail.extended-simulation.data.' + data.type | translate) +
          ' ' +
          data.unitOfMeasurement
      }}
    </td>
    <td class="simulationValue">{{ data.comparison }}</td>
    <td>
      <span class="simulationValue">{{ data.extended }} </span>
      <ng-container *ngIf="data.diff !== ('n/a' | translate)">
        <span *ngIf="data.isPositive > 0" class="text-color--primary-500 text--small">+</span>
        <span
          class="text--small"
          [ngClass]="
            data.isPositive > 0
              ? 'text-color--primary-500'
              : data.isPositive < 0
                ? 'text-color--warn-500'
                : ''
          "
          >{{ data.diff }}</span
        >
        <mat-icon *ngIf="data.isPositive > 0" class="text-color--primary-500 text--small"
          >arrow_upward</mat-icon
        >
        <mat-icon *ngIf="data.isPositive < 0" class="text-color--warn-500 text--small"
          >arrow_downward</mat-icon
        >
      </ng-container>
    </td>
  </ng-template>

  <table>
    <tr>
      <th>{{ 'feed-profit.detail.extended-simulation.type' | translate }}</th>
      <th>{{ 'feed-profit.detail.extended-simulation.base-simulation' | translate }}</th>
      <th>{{ 'feed-profit.detail.extended-simulation.extended-simulation' | translate }}</th>
    </tr>

    <!-- avgAmountDeliveredGrowFinisher -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'avgAmountDeliveredGrowFinisher',
            '',
            data.extended?.avgAmountDeliveredGrowFinisher,
            data.comparison?.avgAmountDeliveredGrowFinisher,
            '1.01-02',
            '1.0-0'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- squareMeterPerGrowFinisher -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'squareMeterPerGrowFinisher',
            '',
            data.extended?.squareMeterPerGrowFinisher,
            data.comparison?.squareMeterPerGrowFinisher,
            '1.01-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Start weight -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'startWeight',
            '(kg)',
            data.extended?.startWeight,
            data.comparison?.startWeight,
            '1.01-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Piglet price -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'pigletPrice',
            '(' + currencySymbol + ')',
            data.extended?.pigletPrice,
            data.comparison?.pigletPrice,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Package price per kg -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'feedPackagePrice',
            '(' + currencySymbol + ')',
            data.extended?.feedPackagePrice,
            data.comparison?.feedPackagePrice,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Occupancy rate -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'occupancyRate',
            '(%)',
            data.extended?.occupancyRate,
            data.comparison?.occupancyRate,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Growth -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow('growth', '', data.extended?.growth, data.comparison?.growth, '1.02-02'),
        }"
      ></ng-template>
    </tr>

    <!-- Effect of start weight on days -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'divergingDaysStartWeight',
            '',
            data.extended?.divergingDaysStartWeight,
            data.comparison?.divergingDaysStartWeight,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Effect of slaughtered weight on days -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'divergingDaysSlaughteredWeight',
            '',
            data.extended?.divergingDaysSlaughteredWeight,
            data.comparison?.divergingDaysSlaughteredWeight,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Effect of growth on days -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'divergingDaysGrowth',
            '',
            data.extended?.divergingDaysGrowth,
            data.comparison?.divergingDaysGrowth,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Amount of days -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'amountOfDays',
            '',
            data.extended?.amountOfDays,
            data.comparison?.amountOfDays,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Meat percentage -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'meatPercentage',
            '(%)',
            data.extended?.meatPercentage * 100,
            data.comparison?.meatPercentage * 100,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Muscle thickness -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'milimeterMuscle',
            '(mm)',
            data.extended?.milimeterMuscle,
            data.comparison?.milimeterMuscle,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Neck thickness (might be lard)-->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'milimeterNeck',
            '(mm)',
            data.extended?.milimeterNeck,
            data.comparison?.milimeterNeck,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Amount of rounds -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'amountOfRounds',
            '',
            data.extended?.amountOfRounds,
            data.comparison?.amountOfRounds,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Effect of start weight on energy -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'divergingEnergyFromGrowthStartStartWeight',
            '',
            data.extended?.divergingEnergyFromGrowthStartStartWeight,
            data.comparison?.divergingEnergyFromGrowthStartStartWeight,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Effect of delivered weight on energy -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'divergingEnergyFromGrowthEndDeliveredWeight',
            '',
            data.extended?.divergingEnergyFromGrowthEndDeliveredWeight,
            data.comparison?.divergingEnergyFromGrowthEndDeliveredWeight,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Effect of growth on energy -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'divergingEnergyDivergingGrowth',
            '',
            data.extended?.divergingEnergyDivergingGrowth,
            data.comparison?.divergingEnergyDivergingGrowth,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Energy conversion -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'energyConversion',
            '',
            data.extended?.energyConversion,
            data.comparison?.energyConversion,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Effect of start weight on feed costs -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'effectDifferentStartWeightOnFeedCosts',
            '(' + currencySymbol + ')',
            data.extended?.effectDifferentStartWeightOnFeedCosts,
            data.comparison?.effectDifferentStartWeightOnFeedCosts,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Effect of growth on feed costs -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'effectDifferenceGrowthOnFeedCost',
            '(' + currencySymbol + ')',
            data.extended?.effectDifferenceGrowthOnFeedCost,
            data.comparison?.effectDifferenceGrowthOnFeedCost,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Effect of slaughtered weight on feed costs -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'effectSlaughteredWeightOnFeedCost',
            '(' + currencySymbol + ')',
            data.extended?.effectSlaughteredWeightOnFeedCost,
            data.comparison?.effectSlaughteredWeightOnFeedCost,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Energy use -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'energyUse',
            '',
            data.extended?.energyUse,
            data.comparison?.energyUse,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Feed costs per growth -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'feedCostPerKgPerGrowth',
            '(' + currencySymbol + ')',
            data.extended?.feedCostPerKgPerGrowth,
            data.comparison?.feedCostPerKgPerGrowth,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Feed profit per grow finisher -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'feedProfitPerDeliveredGrowFinisher',
            '(' + currencySymbol + ')',
            data.extended?.feedProfitPerDeliveredGrowFinisher,
            data.comparison?.feedProfitPerDeliveredGrowFinisher,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Profit per grow finisher -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'profitPerGrowFinisher',
            '(' + currencySymbol + ')',
            data.extended?.profitPerGrowFinisher,
            data.comparison?.profitPerGrowFinisher,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Feed costs -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'feedCosts',
            '(' + currencySymbol + ')',
            data.extended?.feedCosts,
            data.comparison?.feedCosts,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>

    <!-- Costs deaths and spoilage  -->
    <tr>
      <ng-template
        [ngTemplateOutlet]="simulationRow"
        [ngTemplateOutletContext]="{
          data: getDataRow(
            'costDeathsAndSpoilage',
            '(' + currencySymbol + ')',
            data.extended?.costDeathsAndSpoilage,
            data.comparison?.costDeathsAndSpoilage,
            '1.02-02'
          ),
        }"
      ></ng-template>
    </tr>
  </table>
</ng-container>
